/**
 * @module store/marathons/actions
 *
 * @version 1.0.1
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetChallenges, apiSetChallenge } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Получеие страницы со стартами
 *
 * @since Version 1.0.0
 */
const getChallenges = async ({ commit, rootGetters }, { limit, offset, userId }) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data, total } = await apiGetChallenges(userSession.accessToken.jwtToken, { limit, offset, userId });

      commit(types.GET_CHALLENGES_ASYNC.SUCCESS, {
        data,
        total,
      });
    } else {
      throw new Error('Неавторизованный пользователь не может получить список стартов.');
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * Action: Set challenge
 *
 * @since Version 1.0.3
 */
const setChallenge = async ({ rootGetters }, challenge) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetChallenge(userSession.accessToken.jwtToken, challenge);
    } else {
      throw new Error('Неавторизованный пользователь не может менять информацию о стартах.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


export default {
  getChallenges,
  setChallenge,
};
